import { pick } from "./helpers";

export const saveUserCredentials = (user, token) => {
  if (!user) {
    throw new Error("Nothing to save to Storage");
  } else {
    const data = pick(
      user,
      "id",
      "name",
      "email",
      "mobile_no",
      "role",
      "profile_pic",
      "doc1_image",
      "doc2_image",
      "doc1_type",
      "doc2_type",
      "username"
    );
    localStorage.setItem("user", JSON.stringify(data));
    localStorage.setItem("auth_token", token);
  }
};

export const getLoggedInUserRole = () => {
  try {
    if (!localStorage.user) {
      return {};
    }
    const { role } = JSON.parse(localStorage.user);
    return role.slug;
  } catch (err) {
    console.log(err);
  }
};
